function parseCartAmount(text) {
  if (!text) return null;
  // Match must start on an actual digit — otherwise a currency prefix like "Rs." gets
  // its trailing dot swept in as if it were the start of the decimal number.
  const match = text.match(/\d[\d.,]*/);
  if (!match) return null;

  const numStr = match[0];
  const lastComma = numStr.lastIndexOf(',');
  const lastDot = numStr.lastIndexOf('.');

  let normalized;
  if (lastComma > lastDot) {
    // comma is the decimal separator (e.g. "435,00" or "1.234,56")
    normalized = numStr.replace(/\./g, '').replace(',', '.');
  } else if (lastDot > lastComma) {
    // dot is the decimal separator (e.g. "1,234.56")
    normalized = numStr.replace(/,/g, '');
  } else {
    normalized = numStr;
  }

  const value = parseFloat(normalized);
  if (isNaN(value)) return null;
  return text.includes('-') ? -value : value;
}

function formatCartAmount(symbol, amount) {
  return `${symbol}${Math.abs(amount).toFixed(2)}`;
}

function setCartText(el, value) {
  if (el.textContent !== value) el.textContent = value;
}

function sumProductTiles(shadow) {
  const tiles = shadow.querySelectorAll('.upcart-public-component-product-tile');
  let compareAtTotal = 0;
  let priceTotal = 0;
  let currencySymbol = null;

  tiles.forEach((tile) => {
    const priceEl = tile.querySelector('.upcart-public-component-product-tile__price');
    const compareAtEl = tile.querySelector('.upcart-public-component-product-tile__price-compare-at');

    // .price and .price-compare-at already reflect the line total (unit price × quantity)
    const price = parseCartAmount(priceEl?.textContent);
    const compareAt = parseCartAmount(compareAtEl?.textContent);

    if (price !== null) {
      priceTotal += price;
      compareAtTotal += compareAt !== null ? compareAt : price;
      if (!currencySymbol) currencySymbol = (priceEl.textContent.match(/[^\d\s.,-]+/) || ['$'])[0];
    }
  });

  return { compareAtTotal, priceTotal, currencySymbol: currencySymbol || '$' };
}

function applyCartDrawerVarA(shadow) {
  console.log('[c-cart-drawer-mvt] applyCartDrawerVarA running');

  const summary = shadow.querySelector('.upcart-public-cart-summary');
  console.log('[c-cart-drawer-mvt] summary found:', !!summary);
  if (!summary) return;

  const { compareAtTotal, priceTotal, currencySymbol } = sumProductTiles(shadow);
  console.log('[c-cart-drawer-mvt] compareAtTotal:', compareAtTotal, 'priceTotal:', priceTotal);
  if (compareAtTotal === 0 && priceTotal === 0) return;

  const subtotalAmount = compareAtTotal;
  const totalAmount = priceTotal;
  const savingsAmount = subtotalAmount - totalAmount;

  summary.style.display = 'none';

  let breakdown = summary.nextElementSibling;
  if (!breakdown || !breakdown.classList.contains('c-cart-drawer-mvt-summary')) {
    breakdown = document.createElement('div');
    breakdown.className = 'c-cart-drawer-mvt-summary';
    breakdown.innerHTML = `
      <style>
        .c-cart-drawer-mvt-summary { padding-bottom: 20px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #000; }
        .c-cart-drawer-mvt-summary__row { display: flex; justify-content: space-between; line-height: 16px; }
        .c-cart-drawer-mvt-summary__row + .c-cart-drawer-mvt-summary__row { margin-top: 8px; }
        .c-cart-drawer-mvt-summary__row--savings span:last-child { color: #2d8a4e; font-weight: 700; }
        .c-cart-drawer-mvt-summary__row--total { border-top: 1px solid #e3e3e3; padding-top: 8px; font-weight: 700; font-size: 16px; line-height: 18px; }
      </style>
      <div class="c-cart-drawer-mvt-summary__row">
        <span>Subtotal</span><span data-field="subtotal"></span>
      </div>
      <div class="c-cart-drawer-mvt-summary__row c-cart-drawer-mvt-summary__row--savings">
        <span>Savings</span><span data-field="savings"></span>
      </div>
      <div class="c-cart-drawer-mvt-summary__row c-cart-drawer-mvt-summary__row--total">
        <span>Total</span><span data-field="total"></span>
      </div>
    `;
    summary.insertAdjacentElement('afterend', breakdown);
  }

  setCartText(breakdown.querySelector('[data-field="subtotal"]'), formatCartAmount(currencySymbol, subtotalAmount));
  setCartText(breakdown.querySelector('[data-field="savings"]'), `−${formatCartAmount(currencySymbol, savingsAmount)}`);
  setCartText(breakdown.querySelector('[data-field="total"]'), formatCartAmount(currencySymbol, totalAmount));
}

let varBSyncToken = 0;
let slimTeeProductId = null;

function syncVarBButtons(upsellBlock) {
  const token = ++varBSyncToken;
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      if (token !== varBSyncToken) return; // a newer sync started after this one — ignore stale result
      const cartVariantIds = new Set(cart.items.map((item) => String(item.variant_id)));
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));

      const bundleItem = upsellBlock.querySelector('.c-cart-drawer-mvt-bundle-item');
      let anyVisible = false;
      if (bundleItem) {
        const alreadyHasSlimTee = slimTeeProductId !== null && cartProductIds.has(slimTeeProductId);
        bundleItem.style.display = alreadyHasSlimTee ? 'none' : '';
        if (!alreadyHasSlimTee) anyVisible = true;
      }

      upsellBlock.querySelectorAll('.c-cart-drawer-mvt-upsell__item:not(.c-cart-drawer-mvt-bundle-item)').forEach((item) => {
        const button = item.querySelector('.c-cart-drawer-mvt-upsell__button[data-variant-id]');
        if (!button) return; // safety net — every non-bundle item should have one
        const inCart = cartVariantIds.has(button.dataset.variantId);
        item.style.display = inCart ? 'none' : '';
        if (!inCart) {
          anyVisible = true;
          button.disabled = false;
          setCartText(button, 'Add to cart');
        }
      });
      upsellBlock.style.display = anyVisible ? '' : 'none';
    })
    .catch(() => {});
}

function addToCartAndRefresh(variantId, button, upsellBlock) {
  button.disabled = true;
  button.textContent = 'Adding...';

  fetch(window.routes?.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((res) => {
      if (!res.ok) throw new Error('Add to cart failed');
      syncVarBButtons(upsellBlock);
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = 'Add to cart';
    });
}

const VAR_B_PRODUCTS = [
  {
    handle: '3d%E2%84%A2-slim-tee-sculpt-support-v1',
    variantId: '57176617877884',
    name: '3D™ Slim Tee',
    image: 'https://cdn.shopify.com/s/files/1/0923/6152/3580/files/CLOSEUPSHOT_11zon.webp?v=1784202262',
    alt: '3D™ - Slim Tee Sculpt & Support',
  },
  {
    handle: '3d%E2%84%A2-anti-chafe-shorts-glide-smooth',
    variantId: '57168810869116',
    name: 'Anti-Chafe Shorts',
    image: 'https://cdn.shopify.com/s/files/1/0923/6152/3580/files/16_11zon_1.webp?v=1783956563',
    alt: '3D™ Anti-Chafe Shorts – Glide & Smooth',
  },
];

function formatMoney(cents) {
  const currency = document.body.dataset.shopCurrency || 'USD';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency,
  }).format(cents / 100);
}

function loadVarBPrices(upsellBlock) {
  VAR_B_PRODUCTS.forEach((product, index) => {
    fetch(`/products/${product.handle}.js`)
      .then((res) => res.json())
      .then((data) => {
        const priceEl = upsellBlock.querySelector(`[data-price-index="${index}"]`);
        if (priceEl) setCartText(priceEl, formatMoney(data.price));
        if (index === 0) setupSlimTeeBundlePicker(upsellBlock, data);
      })
      .catch(() => {});
  });
}

function closeOtherBundleChips(upsellBlock, exceptEl) {
  upsellBlock.querySelectorAll('.c-cart-drawer-mvt-bundle-chip[open]').forEach((el) => {
    if (el !== exceptEl) el.removeAttribute('open');
  });
}

function renderColorList(unitEl, colorImages, onPick) {
  const list = unitEl.querySelector('[data-bundle-color-list]');
  const colors = Object.keys(colorImages);
  list.innerHTML = colors.map((c) => `
    <button type="button" class="c-cart-drawer-mvt-bundle-chip__option" data-color="${c}">
      <img src="${colorImages[c]}&width=120" alt="">
      <span>${c}</span>
    </button>
  `).join('');
  list.querySelectorAll('button').forEach((btn) => {
    btn.addEventListener('click', () => onPick(btn.dataset.color));
  });
}

function renderSizeList(unitEl, productData, color, onPick) {
  const list = unitEl.querySelector('[data-bundle-size-list]');
  const sizes = productData.variants.filter((v) => v.option1 === color);
  list.innerHTML = sizes.map((v) => `
    <button type="button" class="c-cart-drawer-mvt-bundle-chip__option" data-size="${v.option2}" ${v.available ? '' : 'disabled'}>
      <span>${v.option2}${v.available ? '' : ' (sold out)'}</span>
    </button>
  `).join('');
  list.querySelectorAll('button:not(:disabled)').forEach((btn) => {
    btn.addEventListener('click', () => onPick(btn.dataset.size));
  });
}

function setupSlimTeeBundlePicker(upsellBlock, productData) {
  slimTeeProductId = productData.id;
  syncVarBButtons(upsellBlock);

  const rootNode = upsellBlock.getRootNode();
  rootNode.addEventListener('click', (e) => {
    if (!e.target.closest('.c-cart-drawer-mvt-bundle-chip')) closeOtherBundleChips(upsellBlock, null);
  });

  const colorOption = productData.options.find((o) => o.name.toLowerCase() === 'color');
  const allColors = colorOption ? colorOption.values : [];
  // Drop colors with no available size at all — nothing to pick within them anyway.
  const colorImages = {};
  allColors.forEach((c) => {
    const variant = productData.variants.find((v) => v.option1 === c && v.available);
    if (variant) colorImages[c] = variant.featured_image ? variant.featured_image.src : productData.featured_image;
  });

  [0, 1].forEach((unitIndex) => {
    const unitEl = upsellBlock.querySelector(`[data-unit="${unitIndex}"]`);
    if (!unitEl) return;

    const photoEl = unitEl.querySelector('[data-bundle-photo]');
    const colorChip = unitEl.querySelector('[data-bundle-color-chip]');
    const colorThumb = unitEl.querySelector('[data-bundle-color-thumb]');
    const colorLabel = unitEl.querySelector('[data-bundle-color-label]');
    const sizeChip = unitEl.querySelector('[data-bundle-size-chip]');
    const sizeLabel = unitEl.querySelector('[data-bundle-size-label]');

    function selectColor(color, preferredSize) {
      unitEl.dataset.color = color;
      colorThumb.src = `${colorImages[color]}&width=120`;
      colorLabel.textContent = color;
      photoEl.src = `${colorImages[color]}&width=240`;
      photoEl.alt = color;
      colorChip.removeAttribute('open');

      const sizesForColor = productData.variants.filter((v) => v.option1 === color);
      const preferred = preferredSize && sizesForColor.find((v) => v.option2 === preferredSize && v.available);
      const fallback = sizesForColor.find((v) => v.available) || sizesForColor[0];
      const chosen = preferred || fallback;
      selectSize(chosen ? chosen.option2 : null);
      renderSizeList(unitEl, productData, color, selectSize);
    }

    function selectSize(size) {
      unitEl.dataset.size = size || '';
      sizeLabel.textContent = size || 'Select';
      sizeChip.removeAttribute('open');
    }

    renderColorList(unitEl, colorImages, selectColor);
    const defaultColor = colorImages['Navy Blue'] ? 'Navy Blue' : Object.keys(colorImages)[0];
    if (defaultColor) selectColor(defaultColor, 'XL');

    [colorChip, sizeChip].forEach((chip) => {
      chip.addEventListener('toggle', () => {
        if (chip.open) closeOtherBundleChips(upsellBlock, chip);
      });
    });
  });

  const addButton = upsellBlock.querySelector('.c-cart-drawer-mvt-bundle-add');
  if (!addButton || addButton.dataset.bound) return;
  addButton.dataset.bound = 'true';

  addButton.addEventListener('click', () => {
    const items = [0, 1]
      .map((unitIndex) => {
        const unitEl = upsellBlock.querySelector(`[data-unit="${unitIndex}"]`);
        const color = unitEl?.dataset.color;
        const size = unitEl?.dataset.size;
        const variant = productData.variants.find((v) => v.option1 === color && v.option2 === size);
        return variant ? { id: variant.id, quantity: 1 } : null;
      })
      .filter(Boolean);

    if (items.length !== 2) return;

    const originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Add to cart failed');
        addButton.textContent = 'Added';
        setTimeout(() => {
          addButton.disabled = false;
          addButton.textContent = originalText;
        }, 1500);
      })
      .catch(() => {
        addButton.disabled = false;
        addButton.textContent = originalText;
      });
  });
}

function hasLeggingsInCart(itemsList) {
  return Array.from(itemsList.querySelectorAll('.upcart-public-component-product-tile__product-title'))
    .some((el) => el.textContent.toLowerCase().includes('legging'));
}

function applyCartDrawerVarB(shadow) {
  const itemsList = shadow.querySelector('.upcart-public-cart-items');
  console.log('[c-cart-drawer-mvt] VarB — itemsList found:', !!itemsList);
  if (!itemsList) return;

  let upsellBlock = itemsList.querySelector('.c-cart-drawer-mvt-upsell');

  if (!hasLeggingsInCart(itemsList)) {
    if (upsellBlock) upsellBlock.remove();
    return;
  }

  if (upsellBlock) {
    if (itemsList.lastElementChild !== upsellBlock) itemsList.appendChild(upsellBlock);
    syncVarBButtons(upsellBlock);
    return;
  }

  upsellBlock = document.createElement('li');
  upsellBlock.className = 'c-cart-drawer-mvt-upsell';
  upsellBlock.innerHTML = `
    <style>
      .c-cart-drawer-mvt-upsell { display: block; list-style: none; margin: 12px 18px; font-family: Helvetica, Arial, sans-serif; }
      .c-cart-drawer-mvt-upsell__heading { font-size: 12px; font-weight: 700; letter-spacing: 0.5px; color: #7A6F6F; text-transform: uppercase; margin-bottom: 10px; }
      .c-cart-drawer-mvt-upsell__item { display: flex; align-items: center; gap: 12px; background: #faf7f7; border: 1px solid #f0e7e7; border-radius: 12px; padding: 10px; margin-bottom: 12px; }
      .c-cart-drawer-mvt-upsell__item img { width: 40px; height: 40px; object-fit: cover; border-radius: 98px; flex-shrink: 0; }
      .c-cart-drawer-mvt-upsell__info { flex: 1; display: flex; flex-direction: column; gap: 3px; }
      .c-cart-drawer-mvt-upsell__title { font-size: 13px; font-weight: 400; color: #000; line-height: 15px; }
      .c-cart-drawer-mvt-upsell__price { font-size: 13px; font-weight: 700; color: #000; line-height: 15px; }
      .c-cart-drawer-mvt-upsell__button { border: 1.5px solid #c38786; color: #b56c6b; background: #fff; border-radius: 8px; padding: 8px 12px; font-size: 12px; font-weight: 700; line-height: 14px; white-space: nowrap; cursor: pointer; }
      .c-cart-drawer-mvt-upsell__button:disabled { opacity: 0.6; cursor: default; }
      .c-cart-drawer-mvt-bundle-item { flex-direction: column; align-items: stretch; }
      .c-cart-drawer-mvt-bundle-item__top { display: flex; align-items: center; gap: 12px; }
      .c-cart-drawer-mvt-bundle-note { font-size: 11px; color: #7a6f6f; margin-top: 8px; }
      .c-cart-drawer-mvt-bundle-unit { display: flex; align-items: stretch; min-height: 44px; gap: 8px; margin-top: 8px; }
      .c-cart-drawer-mvt-bundle-label { font-size: 11px; font-weight: 700; color: #7a6f6f; width: 34px; flex-shrink: 0; align-self: center; }
      .c-cart-drawer-mvt-bundle-photo { width: 40px; height: 40px; object-fit: cover; border-radius: 10px !important; flex-shrink: 0; align-self: center; background: #eee; }
      .c-cart-drawer-mvt-bundle-chip { position: relative; flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; }
      .c-cart-drawer-mvt-bundle-chip[data-bundle-size-chip] { flex: 0 0 72px; }
      .c-cart-drawer-mvt-bundle-chip summary { flex: 1; display: flex; align-items: center; gap: 6px; list-style: none; cursor: pointer; border: 1px solid #e3e3e3; border-radius: 8px; padding: 0 10px; font-size: 12px; color: #000; background: #fff; }
      .c-cart-drawer-mvt-bundle-chip summary:hover { border-color: rgba(198, 163, 163, 1); }
      .c-cart-drawer-mvt-bundle-chip summary::-webkit-details-marker { display: none; }
      .c-cart-drawer-mvt-bundle-chip__thumb { width: 20px; height: 20px; border-radius: 50%; object-fit: cover; flex-shrink: 0; background: #eee; }
      .c-cart-drawer-mvt-bundle-chip summary span { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
      .c-cart-drawer-mvt-bundle-chip summary svg { flex-shrink: 0; transition: transform 150ms ease; }
      .c-cart-drawer-mvt-bundle-chip[open] summary svg { transform: rotate(180deg); }
      .c-cart-drawer-mvt-bundle-chip__list { position: absolute; bottom: calc(100% + 4px); left: 0; right: 0; max-height: 130px; overflow-y: auto; background: #fff; border: 1px solid #e3e3e3; border-radius: 8px; box-shadow: 0 -6px 16px rgba(0,0,0,0.12); z-index: 3; padding: 3px; }
      .c-cart-drawer-mvt-bundle-chip__option { display: flex; align-items: center; gap: 6px; width: 100%; border: none; background: none; padding: 4px 6px; font-size: 11px; text-align: left; cursor: pointer; border-radius: 5px; font-family: inherit; color: #000; }
      .c-cart-drawer-mvt-bundle-chip__option:hover { background: #f5f0f0; }
      .c-cart-drawer-mvt-bundle-chip__option:disabled { opacity: 0.4; cursor: default; }
      .c-cart-drawer-mvt-bundle-chip__option img { width: 16px; height: 16px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
      .c-cart-drawer-mvt-bundle-add { width: 100%; margin-top: 10px; }
    </style>
    <div class="c-cart-drawer-mvt-upsell__heading">Complete your set</div>
    <div class="c-cart-drawer-mvt-upsell__item c-cart-drawer-mvt-bundle-item">
      <div class="c-cart-drawer-mvt-bundle-item__top">
        <img src="${VAR_B_PRODUCTS[0].image}&width=120" alt="${VAR_B_PRODUCTS[0].alt}" loading="lazy">
        <div class="c-cart-drawer-mvt-upsell__info">
          <div class="c-cart-drawer-mvt-upsell__title">${VAR_B_PRODUCTS[0].name}</div>
          <div class="c-cart-drawer-mvt-upsell__price" data-price-index="0"></div>
        </div>
      </div>
      <div class="c-cart-drawer-mvt-bundle-note">Buy 2 to unlock the bundle price, pick a color and size for each</div>
      ${[0, 1].map((unitIndex) => `
        <div class="c-cart-drawer-mvt-bundle-unit" data-unit="${unitIndex}">
          <span class="c-cart-drawer-mvt-bundle-label">Unit ${unitIndex + 1}</span>
          <img class="c-cart-drawer-mvt-bundle-photo" data-bundle-photo alt="">
          <details class="c-cart-drawer-mvt-bundle-chip" data-bundle-color-chip>
            <summary>
              <img class="c-cart-drawer-mvt-bundle-chip__thumb" data-bundle-color-thumb alt="">
              <span data-bundle-color-label></span>
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5L6 8l3.5-3.5" stroke="#555" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </summary>
            <div class="c-cart-drawer-mvt-bundle-chip__list" data-bundle-color-list></div>
          </details>
          <details class="c-cart-drawer-mvt-bundle-chip" data-bundle-size-chip>
            <summary>
              <span data-bundle-size-label></span>
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5L6 8l3.5-3.5" stroke="#555" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </summary>
            <div class="c-cart-drawer-mvt-bundle-chip__list" data-bundle-size-list></div>
          </details>
        </div>
      `).join('')}
      <button type="button" class="c-cart-drawer-mvt-upsell__button c-cart-drawer-mvt-bundle-add">Add 2 to cart</button>
    </div>
    <div class="c-cart-drawer-mvt-upsell__item">
      <img src="${VAR_B_PRODUCTS[1].image}&width=120" alt="${VAR_B_PRODUCTS[1].alt}" loading="lazy">
      <div class="c-cart-drawer-mvt-upsell__info">
        <div class="c-cart-drawer-mvt-upsell__title">${VAR_B_PRODUCTS[1].name}</div>
        <div class="c-cart-drawer-mvt-upsell__price" data-price-index="1"></div>
      </div>
      <button type="button" class="c-cart-drawer-mvt-upsell__button" data-variant-id="${VAR_B_PRODUCTS[1].variantId}">Add to cart</button>
    </div>
  `;
  itemsList.appendChild(upsellBlock);

  upsellBlock.querySelectorAll('.c-cart-drawer-mvt-upsell__item > .c-cart-drawer-mvt-upsell__button[data-variant-id]').forEach((button) => {
    button.addEventListener('click', () => addToCartAndRefresh(button.dataset.variantId, button, upsellBlock));
  });

  loadVarBPrices(upsellBlock);
  syncVarBButtons(upsellBlock);
}

function applyCartDrawerVarC(shadow) {
  const itemsList = shadow.querySelector('.upcart-public-cart-items');
  console.log('[c-cart-drawer-mvt] VarC — itemsList found:', !!itemsList);
  if (!itemsList) return;

  let resultsBlock = itemsList.querySelector('.c-cart-drawer-mvt-results');
  if (resultsBlock) {
    if (itemsList.lastElementChild !== resultsBlock) itemsList.appendChild(resultsBlock);
    return;
  }

  resultsBlock = document.createElement('li');
  resultsBlock.className = 'c-cart-drawer-mvt-results';
  resultsBlock.innerHTML = `
    <style>
      .c-cart-drawer-mvt-results { display: block; list-style: none; margin: 12px 18px; background: #fdf6f6; border: 1px solid #f0e4e4; border-radius: 14px; font-family: Helvetica, Arial, sans-serif; }
      .c-cart-drawer-mvt-results__header { display: flex; align-items: center; gap: 7px; padding: 12px 14px 4px 14px; justify-content: center; }
      .c-cart-drawer-mvt-results__title { font-weight: 700; font-size: 13px; line-height: 15px; color: #000; }
      .c-cart-drawer-mvt-results__stars { font-size: 12px; line-height: 14px; color: #2d8a4e; }
      .c-cart-drawer-mvt-results__label { font-size: 11px; font-weight: 700; line-height: 13px; color: #7a6f6f; }
      .c-cart-drawer-mvt-results__images { display: flex; gap: 10px; padding: 12px 14px 14px 14px; }
      .c-cart-drawer-mvt-results__image-wrap { flex: 1; display: flex; flex-direction: column; gap: 6px; }
      .c-cart-drawer-mvt-results__image-wrap img { width: 100%; aspect-ratio: 182.5 / 227; object-fit: cover; border-radius: 10px; display: block; }
      .c-cart-drawer-mvt-results__caption { font-size: 11px; font-weight: 700; line-height: 13px; color: #7a6f6f; text-align: center; }
      .c-cart-drawer-mvt-results__caption--after { color: #b56c6b; }
    </style>
    <div class="c-cart-drawer-mvt-results__header">
      <span class="c-cart-drawer-mvt-results__title">Real results</span>
      <span class="c-cart-drawer-mvt-results__stars">★★★★★</span>
      <span class="c-cart-drawer-mvt-results__label">verified customers</span>
    </div>
    <div class="c-cart-drawer-mvt-results__images">
      <div class="c-cart-drawer-mvt-results__image-wrap">
        <img src="https://cdn.shopify.com/s/files/1/0923/6152/3580/files/img-before-cart-test.png?v=1787175971" alt="Before results photo, Week 0" loading="lazy">
        <div class="c-cart-drawer-mvt-results__caption">Week 0</div>
      </div>
      <div class="c-cart-drawer-mvt-results__image-wrap">
        <img src="https://cdn.shopify.com/s/files/1/0923/6152/3580/files/img-after-cart-test.png?v=1787176028" alt="After results photo, Week 4" loading="lazy">
        <div class="c-cart-drawer-mvt-results__caption c-cart-drawer-mvt-results__caption--after">Week 4</div>
      </div>
    </div>
  `;
  itemsList.appendChild(resultsBlock);
}

const SHIPPING_ESTIMATES = {
  GB: { maxDays: 5 },
  US: { maxDays: 7 },
  IE: { maxDays: 7 },
  AU: { maxDays: 10 },
  AE: { maxDays: 10 },
  DEFAULT: { maxDays: 12 },
};

const DISPATCH_CUTOFF_UTC_HOUR = 15; // 3:00 PM GMT

function isWeekendUtc(date) {
  const day = date.getUTCDay();
  return day === 0 || day === 6;
}

function addBusinessDaysUtc(date, days) {
  const result = new Date(date.getTime());
  let added = 0;
  while (added < days) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (!isWeekendUtc(result)) added++;
  }
  return result;
}

function nextBusinessDayUtc(date) {
  const result = new Date(date.getTime());
  do {
    result.setUTCDate(result.getUTCDate() + 1);
  } while (isWeekendUtc(result));
  return result;
}

function getShippingEstimate() {
  const country = window.Shopify?.country || window.__st?.cid;
  const estimate = SHIPPING_ESTIMATES[country] || SHIPPING_ESTIMATES.DEFAULT;
  console.log('[c-cart-drawer-mvt] VarD — detected country:', country, 'maxDays:', estimate.maxDays);
  return estimate;
}

function getCartDrawerVarDState(now) {
  const cutoffToday = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), DISPATCH_CUTOFF_UTC_HOUR, 0, 0));
  const dispatchesToday = now < cutoffToday && !isWeekendUtc(now);

  const { maxDays } = getShippingEstimate();
  const dispatchDate = dispatchesToday ? now : nextBusinessDayUtc(now);
  const deliveryDate = addBusinessDaysUtc(dispatchDate, maxDays);
  const deliveryLabel = new Intl.DateTimeFormat(navigator.language || 'en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).format(deliveryDate);

  if (!dispatchesToday) {
    return { dispatchesToday: false };
  }

  const diffMs = cutoffToday - now;
  const hours = Math.floor(diffMs / 3600000);
  const minutes = Math.floor((diffMs % 3600000) / 60000);
  return { timeText: `${hours}h ${minutes}m`, deliveryLabel, dispatchesToday: true };
}

let varDInterval = null;

function renderCartDrawerVarD(urgencyBlock) {
  const state = getCartDrawerVarDState(new Date());

  const lineEl = urgencyBlock.querySelector('.c-cart-drawer-mvt-urgency__line1');
  const dispatchEl = urgencyBlock.querySelector('[data-field="dispatch"]');

  const lineHtml = state.dispatchesToday
    ? `Order within <span class="c-cart-drawer-mvt-urgency__accent">${state.timeText}</span> for delivery by <span class="c-cart-drawer-mvt-urgency__accent">${state.deliveryLabel}</span>`
    : 'Order today for dispatch tomorrow morning.';
  if (lineEl.innerHTML !== lineHtml) lineEl.innerHTML = lineHtml;

  setCartText(dispatchEl, state.dispatchesToday ? 'Dispatches today' : 'Dispatches tomorrow');
}

function applyCartDrawerVarD(shadow) {
  const cartBody = shadow.querySelector('.upcart-cart-body');
  const announcement = shadow.querySelector('.upcart-public-announcement');
  const rewards = shadow.querySelector('.upcart-public-rewards');
  console.log('[c-cart-drawer-mvt] VarD — cartBody found:', !!cartBody, 'announcement found:', !!announcement, 'rewards found:', !!rewards);
  if (!cartBody) return;

  if (announcement) announcement.style.display = 'none';
  if (rewards) rewards.style.display = 'none';

  let urgencyBlock = shadow.querySelector('.c-cart-drawer-mvt-urgency');
  if (!urgencyBlock) {
    urgencyBlock = document.createElement('div');
    urgencyBlock.className = 'c-cart-drawer-mvt-urgency';
    urgencyBlock.innerHTML = `
      <style>
        .c-cart-drawer-mvt-urgency { display: flex; align-items: center; gap: 12px; padding: 15px 18px; background: #edf6ef; border: 1px solid #e6e5e1; font-family: Helvetica, Arial, sans-serif; }
        .c-cart-drawer-mvt-urgency__icon { display: flex; align-items: center; justify-content: center; width: 38px; height: 38px; border-radius: 50%; background: #2d8a4e; flex-shrink: 0; }
        .c-cart-drawer-mvt-urgency__icon svg { width: 18px; height: 18px; }
        .c-cart-drawer-mvt-urgency__copy { display: flex; flex-direction: column; gap: 4px; }
        .c-cart-drawer-mvt-urgency__line1 { font-family: Helvetica, Arial, sans-serif; font-weight: 500; font-size: 13.5px; line-height: 18px; color: #000; }
        .c-cart-drawer-mvt-urgency__accent { color: #1f6b39; font-weight: 700; }
        .c-cart-drawer-mvt-urgency__dispatch { display: flex; align-items: center; gap: 5px; font-size: 12px; font-weight: 700; line-height: 14px; color: #2d8a4e; }
      </style>
      <div class="c-cart-drawer-mvt-urgency__icon">
       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path d="M0.75 2.25H12V12H0.75V2.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 6H15L17.25 8.25V12H12V6Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.125 15.75C5.16053 15.75 6 14.9105 6 13.875C6 12.8395 5.16053 12 4.125 12C3.08947 12 2.25 12.8395 2.25 13.875C2.25 14.9105 3.08947 15.75 4.125 15.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.875 15.75C14.9105 15.75 15.75 14.9105 15.75 13.875C15.75 12.8395 14.9105 12 13.875 12C12.8395 12 12 12.8395 12 13.875C12 14.9105 12.8395 15.75 13.875 15.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      </div>
      <div class="c-cart-drawer-mvt-urgency__copy">
        <div class="c-cart-drawer-mvt-urgency__line1"></div>
        <div class="c-cart-drawer-mvt-urgency__dispatch">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.33 7.29L5.25 10.21L11.67 3.79" stroke="#2d8a4e" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span data-field="dispatch"></span>
        </div>
      </div>
    `;
    cartBody.insertAdjacentElement('afterbegin', urgencyBlock);
  }

  renderCartDrawerVarD(urgencyBlock);

  if (!varDInterval) {
    varDInterval = setInterval(() => {
      const currentBlock = shadow.querySelector('.c-cart-drawer-mvt-urgency');
      if (currentBlock) renderCartDrawerVarD(currentBlock);
    }, 60000);
  }
}

function runCartDrawerMvt() {
  const host = document.querySelector('#upCart');
  console.log('[c-cart-drawer-mvt] runCartDrawerMvt — host found:', !!host, 'shadowRoot found:', !!host?.shadowRoot, 'body classes:', document.body.className);
  if (!host || !host.shadowRoot) return;

  if (document.body.classList.contains('c-cartDrawerMvtVarA')) {
    applyCartDrawerVarA(host.shadowRoot);
  } else if (document.body.classList.contains('c-cartDrawerMvtVarB')) {
    applyCartDrawerVarB(host.shadowRoot);
  } else if (document.body.classList.contains('c-cartDrawerMvtVarC')) {
    applyCartDrawerVarC(host.shadowRoot);
  } else if (document.body.classList.contains('c-cartDrawerMvtVarD')) {
    applyCartDrawerVarD(host.shadowRoot);
  }
}

function setupCartDrawerMvtObserver() {
  const cartElement = document.querySelector('#upCart');
  console.log('[c-cart-drawer-mvt] setupCartDrawerMvtObserver — cartElement found:', !!cartElement);

  if (!cartElement) {
    setTimeout(setupCartDrawerMvtObserver, 500);
    return;
  }

  const observer = new MutationObserver((mutations) => {
    const hasRelevantChanges = mutations.some((mutation) =>
      mutation.type === 'childList' ||
      mutation.type === 'attributes' ||
      (mutation.target.shadowRoot && mutation.target === cartElement)
    );

    if (hasRelevantChanges) {
      runCartDrawerMvt();
    }
  });

  observer.observe(cartElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-count', 'class', 'style'],
  });

  if (cartElement.shadowRoot) {
    observer.observe(cartElement.shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  // The test's body class can be added after this point (e.g. Intelligems' ig:ready
  // firing post-DOMContentLoaded, or its preview mode's own async bucketing) — re-check
  // whenever it shows up instead of only reacting to the cart's own DOM changes.
  new MutationObserver(() => runCartDrawerMvt()).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  runCartDrawerMvt();
}

document.addEventListener('DOMContentLoaded', setupCartDrawerMvtObserver);
